import { useCallback } from "react";
import { trackEvent, trackEventOnce } from "../utils/browserAnalytics";
import { getPostHog, identifyPostHogUser, isFeatureFlagEnabled, resetPostHogUser, setUserProperties } from "../utils/posthogConfig";

/**
 * React hook for PostHog analytics
 * Provides typed access to PostHog functionality
 */
export function usePostHog() {
    const track = useCallback(async (eventName: string, properties?: Record<string, any>) => {
        await trackEvent(eventName, properties);
    }, []);

    /** Screen-reached steps: once per tab, so a reload does not refire the funnel step. */
    const trackOnce = useCallback(async (eventName: string, key: string, properties?: Record<string, any>) => {
        await trackEventOnce(eventName, key, properties);
    }, []);

    const identify = useCallback((userId: string, properties?: Record<string, any>) => {
        identifyPostHogUser(userId, properties);
    }, []);

    const reset = useCallback(() => {
        resetPostHogUser();
    }, []);

    const setProperties = useCallback((properties: Record<string, any>) => {
        setUserProperties(properties);
    }, []);

    const isFeatureEnabled = useCallback((flagKey: string): boolean => {
        return isFeatureFlagEnabled(flagKey);
    }, []);

    return {
        track,
        trackOnce,
        identify,
        reset,
        setProperties,
        isFeatureEnabled,
        posthog: getPostHog(),
    };
}
